// @flow

import $ from 'jquery'

// легаси код
export const attachDragger = (node: JQuery) => {
  let attachment = false
  let lastPosition
  let position
  let difference

  $(node).on('mousedown', (e) => {
    attachment = true
    // $FlowFixMe[prop-missing]
    lastPosition = [e.clientX, e.clientY]
  })

  $(node).on('mousemove', (e) => {
    if (!attachment) {
      return
    }

    // $FlowFixMe[prop-missing]
    position = [e.clientX, e.clientY]
    difference = [position[0] - lastPosition[0], position[1] - lastPosition[1]]
    $(node).scrollLeft($(node).scrollLeft() - difference[0])
    $(node).scrollTop($(node).scrollTop() - difference[1])
    // $FlowFixMe[prop-missing]
    lastPosition = [e.clientX, e.clientY]
  })

  $(node).on('mouseup', () => {
    attachment = false
  })

  $(window).on('mouseup', () => {
    attachment = false
  })
}
